/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.CompanySettings = {

  initializeUpload() {
    $(document).on('change', '#image-file-input', _.bind(this._validateFile, this));
    $(document).on('click', '.file_upload_cancel', _.bind(this._resetFileInputField, this));
    $(document).on('click', '.file_upload_cancel', _.bind(this._resetFileInputField, this));

    return $(document).on('click', 'input#setting_vendor_registration',  () => $("label[for='setting_vendor_registration']").toggleClass('disabled'));
  },

  _resetFileInputField(event) {
    $('#image-file-input').val('');
    $('.uploadrow').addClass('hide');
    return $('.file_upload_name').text('');
  },

  _showFileName(target) {
    const fileName = target[0].files[0].name;
    $('.uploadrow').removeClass('hide');
    return $('.file_upload_name').text(fileName);
  },

  _showError() {
    $('.uploadrow').removeClass('hide');
    $('.file_upload_name').html('<small class="error">'+ I18n.t('company_settings.generals.validation.max_file_size_exceeded') + '</small>');
    $('.file_upload_name').addClass('error');
    return $('#image-file-input').val('');
  },

  _validateFile(event) {
    const $target = $(event.currentTarget);
    // Maximum 1 MB file is allowed
    if ($target[0].files[0].size < 1048576) {
      return this._showFileName($target);
    } else {
      return this._showError();
    }
  },

  _toggleTabsVisibility() {
    return $('#my-profile-tabs > .tab-title > a').click(function() {
      const activeTabContent = $(this).attr('data');
      $('#my-profile-tabs > .tab-title > a').not(activeTabContent).removeClass('active');
      $(this).toggleClass('active');
      $('#my-profile-tabs-details > .content').not(activeTabContent).removeClass('active');
      return document.getElementById(activeTabContent).classList.toggle('active');
    });
  }

};
